import React from 'react';
import { useNavigate } from 'react-router-dom';
import './Dashboard.css';

export default function WorkLogHome() {
  const navigate = useNavigate();

  const features = [
    {
      key: 'entry',
      icon: '📝',
      title: '日志录入',
      desc: '填写每日工作重点和详细内容',
      path: '/work-logs/entry'
    },
    {
      key: 'groups',
      icon: '👥',
      title: '项目组管理',
      desc: '管理项目组和成员',
      path: '/work-logs/groups'
    },
    {
      key: 'overview',
      icon: '📋',
      title: '日志总览',
      desc: '查看所有日志记录',
      path: '/work-logs/overview'
    },
    {
      key: 'report',
      icon: '📈',
      title: '月报',
      desc: '生成月度工作报告',
      path: '/work-logs/report'
    },
    {
      key: 'import',
      icon: '📥',
      title: '日志导入',
      desc: '批量导入历史日志',
      path: '/work-logs/import'
    },
    {
      key: 'attachments',
      icon: '📎',
      title: '附件总览',
      desc: '查看和管理所有日志附件',
      path: '/work-logs/attachments'
    },
    {
      key: 'doc-projects',
      icon: '📁',
      title: '项目文档',
      desc: '管理项目文件夹和文档',
      path: '/work-logs/doc-projects'
    }
  ];

  return (
    <div className="dashboard-container">
      <div className="dashboard-header">
        <h2>📅 工作日志</h2>
      </div>

      <div style={{
        display: 'grid',
        gridTemplateColumns: 'repeat(auto-fill, minmax(280px, 1fr))',
        gap: 20,
        marginTop: 24
      }}>
        {features.map(f => (
          <div
            key={f.key}
            onClick={() => navigate(f.path)}
            style={{
              padding: 24,
              background: '#fff',
              borderRadius: 12,
              border: '1px solid #e8e8e8',
              cursor: 'pointer',
              transition: 'all 0.2s',
              boxShadow: '0 2px 8px rgba(0,0,0,0.04)'
            }}
            onMouseEnter={(e) => {
              e.currentTarget.style.transform = 'translateY(-4px)';
              e.currentTarget.style.boxShadow = '0 8px 24px rgba(0,0,0,0.12)';
              e.currentTarget.style.borderColor = '#1890ff';
            }}
            onMouseLeave={(e) => {
              e.currentTarget.style.transform = 'translateY(0)';
              e.currentTarget.style.boxShadow = '0 2px 8px rgba(0,0,0,0.04)';
              e.currentTarget.style.borderColor = '#e8e8e8';
            }}
          >
            <div style={{ fontSize: 36, marginBottom: 12 }}>{f.icon}</div>
            <div style={{ fontSize: 18, fontWeight: 600, marginBottom: 8, color: '#333' }}>{f.title}</div>
            <div style={{ fontSize: 14, color: '#666' }}>{f.desc}</div>
          </div>
        ))}
      </div>
    </div>
  );
}
